<ng-container *ngIf="$currentStore | async as store">
  <div class="max-xs:mt-[10px] max-xs:mb-[25px] my-[30px] text-[14px] font-extralight">{{ 'bookingPage.subtitleSidebar' | translate }}</div>

  <div class="mb-[30px]">
    <h1 class="text-[24px] leading-[24px] font-medium mb-[10px]">{{ store.name }}</h1>
    <div class="store-info-item">{{ store.address.address }}</div>
    <div class="store-info-item" *ngIf="store.address.postalCode || store.address.city">
      <span class="store-info-item__address empty:hidden">{{ store.address.postalCode }}</span>
      <span class="store-info-item__address empty:hidden">{{ store.address.city }}</span>
    </div>
    <div class="store-info-item">{{ store.address.phoneNrMobile }}</div>
    <div class="store-info-item">{{ store.email }}</div>
    <a pm-button class="store-info-item break-all !h-[auto]" [href]="store.homepage" [pmType]="'link'" target="_blank">{{store.homepage}}</a>
  </div>
</ng-container>
